import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Button, Modal, Image, ListGroup, Carousel, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";


// import required modules
// import { Autoplay, Pagination, Navigation, EffectCoverflow } from "swiper";
// import { height } from '@mui/system';

import "../main-style.css"
import axios from 'axios';
import HeroComponent from './hero.component';
import Stories from './stories';
import ContactForm from '../contact/contact-form';
import { ShowEvents } from './showevents';
import { sortDatesWithPastEventsLast } from '../../tools/main';

export default function Home() {
    const navigate = useNavigate()
    const [isMounted, didMount] = useState(false)
    const [loading, isLoading] = useState(true)
    const [events, setEvents] = useState([...Array(10).keys()])
    const [latest, setLatest ] = useState([])
    
    const [errMessage, setErrMsg] = useState('')
    
    const getEvents = async ()=>{
        const response = await axios.post("/event/all").then(res => {
            if (res.data.success) {
                // Sort events: today's events, then upcoming by nearest date, then past by most recent
                const sortedEvents = sortDatesWithPastEventsLast(res.data.events);
                return sortedEvents;
            } else {
                throw new Error('Not successful in retrieving data.')
            }
        }).catch(error =>{
            return error
        })
        return response
    }

    useEffect(()=> {
        
        async function fetchData(){
            const response = await getEvents().then(result=> {
                // Events are sorted: today's events, then upcoming by nearest date, then past by most recent
                console.log('Home page events received (sorted):', result);
                setEvents(result)
                didMount(true)
            }).catch(error=>{
                setErrMsg('Can not retrieve CSAM events at the moment. Please try again later.')
                console.log(error)
                didMount(true)
            })
        }

        fetchData();

        
    }, [])

    useEffect(()=> {
        if (isMounted) isLoading(false)
    },[isMounted])

    return (
        <Container id="home-container">
            {/* Home Banner */}
            <HeroComponent />
            <div id="home-body">
                <section>
                    <ShowEvents events = {events} /> 
                </section>

                <section>
                    <Stories />
                </section>

                <section>
                    <ContactForm />
                </section>
           </div>
        </Container>

    )
}


